import { Spinner } from './Spinner'

export const PageLoader: React.FC = () => {
   return (
      <div className="min-h-screen flexc">
         <Spinner />
      </div>
   )
}
